import SupaLink from "../components/SupaLink";
import CoolTypedThings from "../components/CoolTypedThings";
import { Grid2 as Grid, IconButton} from "@mui/material";
import { JSX, useContext, useState } from "react";
import { rootContext } from "../contexts/rootContext";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import SupaLinkDialog from "../components/SupaLinkDialog";
import GitLogs from "../components/GitLogs";

function Home() {
    const context = useContext(rootContext);

    const [open, setOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modelTitleColor, setModalTitleColor] = useState("black");
    const [modalContent, setModalContent] = useState(<></>);

    const BrokProfileContent = () => (<>
        <span>
            {`Brok Stafford has a deep love for any and all software development, but as of late has a fond interest in web development and GIS.
            He is a video game enjoyer (top 3: Oblivion, Dragon Age Origins, WoW), tea sipper (`}
            <a 
                style={{
                    color: context.theme.text.contrast5,
                    cursor: `url(${context.theme.cursor.pointer}), default`
                }} 
                href="https://meileaf.com/tea/jade-star-8/" 
                target="_blank"
            >
                fav
            </a>
            {`), insect pursuer (`}
            <a 
                style={{
                    color: context.theme.text.contrast5,
                    cursor: `url(${context.theme.cursor.pointer}), default`
                }} 
                href="https://www.inaturalist.org/taxa/47982-Asilidae" 
                target="_blank"
            >
                fav
            </a>
            {`), and outdoor roamer (`}
            <a 
                style={{
                    color: context.theme.text.contrast5,
                    cursor: `url(${context.theme.cursor.pointer}), default`
                }} 
                href="https://en.wikipedia.org/wiki/Buffalo_National_River"
                target="_blank"
            >
                fav
            </a>
            {`).`}
        </span>
        <Grid sx={{ marginTop: "5px"}} spacing={0}>
            <IconButton 
                sx={{
                    cursor: `url(${context.theme.cursor.pointer}), default`
                }} 
                href="https://www.linkedin.com/in/brokanstafford/" 
                target="_blank"
            >
                <LinkedInIcon sx={{ 
                    fontSize: "30px", 
                    color: context.theme.text.contrast4
                }} />
            </IconButton>
            <IconButton 
                sx={{
                    cursor: `url(${context.theme.cursor.pointer}), default`
                }} 
                href="https://github.com/BrokanXYZ" 
                target="_blank"
            >
                <GitHubIcon sx={{ 
                    fontSize: "30px",
                    color: context.theme.text.contrast1
                }} />
            </IconButton>
        </Grid>
    </>);

    const openModal = (title: string, titleColor: string, content: JSX.Element) => {
        setModalTitle(title);
        setModalTitleColor(titleColor);
        setModalContent(content);
        setOpen(true);
    }

    return (<>
        <Grid size="auto" sx={{ fontSize: "24px", marginLeft: "25px"}}>
            <Grid container justifyContent="space-between">
                <Grid sx={{lineHeight: "40px"}} size={12}>
                    {"Howdy,"}
                </Grid>
                <Grid>
                    {" my name is "} 
                    <SupaLink text="Brok Stafford" handleClick={() => openModal("Brok Stafford", context.theme.text.contrast2, <BrokProfileContent />)} />
                    {"."}
                </Grid>
            </Grid>
        </Grid>
        <Grid size="auto" sx={{ 
            marginTop: "10px",
            marginLeft: "25px",
            marginRight: "25px",
            marginBottom: context.isScreenWayTooSmall ? "40px" : "25px",
            height: "5vh" 
        }}>
            <CoolTypedThings theme={context.theme}/>
        </Grid>
        <Grid 
            size="grow" 
            sx={{ 
                overflowY: "scroll", 
                scrollbarColor: `${context.theme.text.contrast4} ${context.theme.background}`,
            }}
            >
                <GitLogs smallScreen={context.isScreenWayTooSmall} openModal={openModal}/>
        </Grid>
        <SupaLinkDialog 
            open={open}
            setOpen={setOpen}
            title={modalTitle}
            titleColor={modelTitleColor}
            content={modalContent}
        />
    </>);
}

export default Home;